module.exports = __webpack_public_path__ + "media/images/icon_business_type_16-16-594b372505875809771375377501b5e0.png";